import { FeatureFlagType } from "@/gql/graphql";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { metaQuery } from "@/app/Meta/GraphQL/metaQuery";

export function useFeatureFlag(type: FeatureFlagType) {
  const { data } = useSuspenseGqlQuery(metaQuery, {});

  return !!data.meta.feature_flags.find((flag) => flag.type === type)?.enabled;
}
